import { StatusInfo } from '@alert-manager/lib';

export const statusAPI = {
  async getStatus(): Promise<StatusInfo> {
    try {
      const response = await fetch(`/api/status`);

      if (!response.ok) {
        throw new Error('Failed to fetch status');
      }

      return await response.json();
    } catch {
      // Return fallback status info on error
      return {
        version: 'Unknown',
        name: 'alert-manager',
        uptime: 0,
        timestamp: new Date().toISOString(),
      };
    }
  },
};
